/**
 * Backend API base URL (no trailing slash).
 *
 * Local dev:
 * - Default: "" → fetch("/api/...") is same-origin; Vite proxies /api → localhost:3001 (no CORS).
 * - If VITE_API_BASE_URL points at Render/production hosts, we still use "" in dev unless
 *   VITE_ALLOW_REMOTE_API_IN_DEV=1 (avoids browser CORS to a server that may not allow localhost).
 *
 * Production:
 * - VITE_API_BASE_URL or VITE_API_URL if set, else Render default.
 */
function trimBase(v) {
  if (typeof v !== 'string') return '';
  return v.trim().replace(/\/$/, '');
}

export const API_BASE_URL = (() => {
  const explicit =
    trimBase(import.meta.env.VITE_API_BASE_URL) ||
    trimBase(import.meta.env.VITE_API_URL);

  if (import.meta.env.DEV) {
    if (import.meta.env.VITE_ALLOW_REMOTE_API_IN_DEV === '1' && explicit) {
      return explicit;
    }
    if (!explicit) return '';
    // Remote hosted API from local Vite → use proxy + local backend (run server on 3001)
    if (/onrender\.com|render\.com|vercel\.app|netlify\.app/i.test(explicit)) {
      return '';
    }
    return explicit;
  }

  if (explicit) return explicit;
  return 'https://time-to-talk.onrender.com';
})();
